import {Button} from "~/components/ui/button.jsx";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import {Card, CardContent} from "~/components/ui/card.jsx";
import {Input} from "~/components/ui/input.jsx";
import Refs from "~/components/sandbox/Refs.jsx";

const colors = ["pink", "blue", "green"]
const sizes = ["sm", "md", "lg", "xl", "2xl"]

export default function () {
  return (
    <div className="py-32 space-y-8 container mx-auto">
      
      <div className="space-x-4 hidden">
        <Popover>
          <PopoverTrigger>
            <Button size="lg" className="" variant="ghost">Filter</Button>
          </PopoverTrigger>
          <PopoverContent align="start">Place content for the popover here.</PopoverContent>
        </Popover>

        <Popover>
          <PopoverTrigger>
            <Button size="xl" className="text-xl font-normal" variant={'outline'}>Фотозоны</Button>
          </PopoverTrigger>
          <PopoverContent align="start">Place content for the popover here.</PopoverContent>
        </Popover>
      </div>

      <div className="max-w-lg hidden">
        <Card>
          <CardContent>
            <div className="space-y-4">
              <Input type="text" size="xl"/>
              <Button size="xl">Оформить заказ</Button>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="hidden">
        <Refs/>
      </div>

      <div>
        {colors.map(color => (
          <div className="space-x-4 pb-8">
            {sizes.map(size => (
              <Button size={size} color={color} variant={'ghost'} className="font-bold text-gray-800">Brand Button</Button>
            ))}
          </div>
        ))}
      </div>

      <Button variant={'outline'}>Outline</Button>
      <Button variant={'ghost'}>Outline</Button>

    </div>
  )
}